// @flow

export const transformSimilarItemsFromV3 = (similarItems: any[]) => {
    const mappedItems = similarItems.map<any>((algoliaItem: any) => transformSimilarItemFromV3(algoliaItem));
    return mappedItems;
};

const transformSimilarItemFromV3 = (algoliaItem: any) => {
    const transformed = {
        biddingInfo: {},
        buyNow: { price: algoliaItem.buyNowPrice, status: algoliaItem.buyNowStatus },
        catalog: {
            catalogId: algoliaItem.catalog.id,
            catalogStatus: algoliaItem.catalog.status,
            currency: algoliaItem.currency,
            hasVideo: false,
            isCatalogOnly: algoliaItem.auctionType === 'catalogOnly',
            saleStartTs: algoliaItem.saleStartTs,
            title: algoliaItem.catalog.title,
        },
        catalogRegistration: {},
        item: {
            highBidEstimate: algoliaItem.highBidEstimate,
            imageVersion: algoliaItem.imageVersion,
            index: 9999,
            isSEOExcluded: algoliaItem.SEOExcluded,
            itemId: algoliaItem.itemId,
            lotNumber: algoliaItem.lotNumber,
            lowBidEstimate: algoliaItem.lowBidEstimate,
            photos: algoliaItem.photos,
            sellerId: algoliaItem.house.id,
            startPrice: algoliaItem.currentBid,
            title: algoliaItem.title,
        },
        liveItemStatus: {},
        promoted: Boolean(algoliaItem.promoted),
        seller: { sellerName: algoliaItem.house.name },
        version: '20191113', // version of this model
    };
    return transformed;
};
